import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { localize } from 'common/utils';
import { LocalisedValue } from 'modules/shared-menu/types';

import { OptionBindingPurchasabilityValidationError } from './OfferTags';

type Props = {
  primaryLanguage: Language;
  purchasabilityValidationErrors: {
    optionName: LocalisedValue[];
    error: OptionBindingPurchasabilityValidationError;
  }[];
};

export const PURCHASABILITY_ERROR_TRANSLATIONS = {
  all_option_values_disabled: 'menu-item.purchasability-errors.all-option-values-disabled',
  too_many_disabled_option_values: 'menu-item.purchasability-errors.too-many-disabled-option_values',
  binding_missing_multi_choice_config:
    'Something looks wrong in the option configuration, please try removing & re-adding the option',
};

const List = styled.ul`
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
`;

const ListItem = styled.li`
  margin: 0;
  padding: 0;
`;

export const PurchasabilityErrorList = ({ primaryLanguage, purchasabilityValidationErrors }: Props) => {
  return purchasabilityValidationErrors.length > 0 ? (
    <div>
      <FormattedMessage id="menu-item.unpurchasable-because-options" />
      <List>
        {purchasabilityValidationErrors.map((error, index) => (
          <ListItem key={index}>
            <strong>{localize(error.optionName, primaryLanguage)}:</strong>{' '}
            <FormattedMessage id={PURCHASABILITY_ERROR_TRANSLATIONS[error.error]} />
          </ListItem>
        ))}
      </List>
    </div>
  ) : null;
};
